import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Card,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import platforms from "../../constants/platforms.json"

function SearchProduct({ handleSubmit, scrapedProductData, loader, setStep }) {
  const [validated, setValidated] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState(platforms[0].name);
  let specs = "";
  const keyword = "";
  const title = scrapedProductData?.title.length > 0 ? scrapedProductData.title.toString().trim() : "";
  const description = scrapedProductData?.description.length > 0 ? scrapedProductData?.description.toString().trim() : "";

  if (Array.isArray(scrapedProductData?.features)) {
    specs = scrapedProductData.features.map(
      (feature) => `${feature.name}:${feature.value}`
    );
    specs = specs.toString().trim();
  }
  const gradeLevels = scrapedProductData?.gradeLevels || "";
  const subjects = scrapedProductData?.subjects || "";
  const resourceType = scrapedProductData?.resourceType || "";
  const formatsIncluded = scrapedProductData?.formatsIncluded || "";

  const [formData, setFormData] = useState({
    title,
    description,
    gradeLevels,
    subjects,
    resourceType,  
    formatsIncluded,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleBackButtonClick = () => {
    setStep(1)
  };

  const handlePlatformSelection = (eventKey) => {
    setSelectedPlatform(eventKey);
    handleInputChange({ target: { name: "platform", value: eventKey } });
  };

  function handleFormSubmit(event) {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (
      formData.title === "" ||
      formData.description === "" || "") {
      return false;
    }
    const updatedFormData = {
      ...formData,
      description: formData.description.replace(/['"]/g, ''),
    };

    handleSubmit(event, updatedFormData)
  }

  return (
    <Card className="search-product-card">
      <Card.Header className="form-header">Optimize Data</Card.Header>
      <Card.Body>
        <Container>
          <Row>
            <Col className="product-area-content">
              <Form
                onSubmit={handleFormSubmit}
                noValidate
                validated={validated}
              >
                <Container>
                  <Row>
                    <Col xl="12">
                      <Form.Group controlId="formTitle" className="mb-3">
                        <Form.Control
                          type="text"
                          name="title"
                          placeholder="Title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formDescription" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="description"
                          placeholder="Description"
                          value={formData.description}
                          onChange={handleInputChange}
                          required
                          style={{ height: '33vh' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formGradeLevels" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="gradeLevels"
                          placeholder="Grade Levels"
                          value={formData.gradeLevels}
                          onChange={handleInputChange}
                          required
                          style={{ height: '10vh' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formSubjects" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="subjects"
                          placeholder="Subjects"
                          value={formData.subjects}
                          onChange={handleInputChange}
                          required
                          style={{ height: '10vh' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formResourceType" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="resourceType"
                          placeholder="Resource Type"
                          value={formData.resourceType}
                          onChange={handleInputChange}
                          required
                          style={{ height: '10vh' }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formFormatsIncluded" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="formatsIncluded"
                          placeholder="Formats Included"
                          value={formData.formatsIncluded}
                          onChange={handleInputChange}
                          required
                          style={{ height: '10vh' }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="12">
                      {loader ? (
                        <Button variant="primary" disabled>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          &nbsp;&nbsp;Optimizing...
                        </Button>
                      ) : (
                        <Button variant="primary" type="submit">
                          Optimize
                        </Button>
                      )}
                      <span onClick={handleBackButtonClick} style={{ cursor: 'pointer', marginLeft: "20px" }}>
                        Back
                      </span>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
}

export default SearchProduct;
